import type { CSSProperties } from "react";

const STAGGER_ENTRANCE_DELAY_MS = [100, 200, 300, 400, 500, 600] as const;

export const MARKETING_GRID_CARD_SURFACE =
	"group relative flex h-full flex-col overflow-hidden rounded-xl border border-border/80 bg-card/40 ring-1 ring-border/40 transition-colors duration-200 hover:border-primary/45";

export const MARKETING_GRID_CARD_CLASSES = `${MARKETING_GRID_CARD_SURFACE} animate-in fade-in slide-in-from-bottom-6 duration-700 fill-mode-both motion-reduce:animate-none motion-reduce:opacity-100`;

export const MARKETING_GRID_CARD_OVERLAY_CLASSES =
	"pointer-events-none absolute inset-0 bg-linear-to-br from-primary/10 to-transparent opacity-0 transition-opacity duration-200 group-hover:opacity-100";

export const MARKETING_SECTION_ANIM_BASE =
	"animate-in fade-in slide-in-from-bottom-6 duration-700 fill-mode-both motion-reduce:animate-none motion-reduce:opacity-100";

/**
 * Entrance animation classes for list items. Pair with
 * `getStaggeredEntranceDelayStyle` — Tailwind `delay-*` does not set
 * `animation-delay` for `animate-in`.
 */
export function getStaggeredAnimationClasses(
	_index: number,
	baseClasses = MARKETING_SECTION_ANIM_BASE,
): string {
	return baseClasses;
}

/** Stagger in milliseconds (100ms steps) for version lists and similar. */
export function getStaggeredEntranceDelayStyle(index: number): {
	animationDelay: string;
} {
	const delayMs =
		index < STAGGER_ENTRANCE_DELAY_MS.length
			? STAGGER_ENTRANCE_DELAY_MS[index]
			: STAGGER_ENTRANCE_DELAY_MS[STAGGER_ENTRANCE_DELAY_MS.length - 1];
	return { animationDelay: `${delayMs}ms` };
}

/** Stagger in seconds for document grids (e.g. legal index cards). */
export function getStaggeredAnimationDelayStyle(
	index: number,
	baseDelaySeconds = 0.4,
	stepSeconds = 0.1,
): { animationDelay: string } {
	const seconds = baseDelaySeconds + index * stepSeconds;
	return {
		animationDelay: `${Number(seconds.toFixed(2))}s`,
	};
}

export function getMarketingSectionAnimStyle(
	delayMs = 0,
): CSSProperties | undefined {
	return delayMs > 0 ? { animationDelay: `${delayMs}ms` } : undefined;
}
